import Joi from 'joi-browser';
import axios from 'axios';
import { WAPIAddress } from 'constants/config';
import * as wapiKeys from '../../../apiKeys';

const wapiKey = process.env.APP_ENV === 'development'? wapiKeys.dev_key : wapiKeys.prod_key;

export const schema = Joi.object().keys({
  old_password: Joi.string().required(),
  new_password: Joi.string().required(),
  confirm_password: Joi.string().required(),
});

export default function changePassword(params) {

  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  return new Promise((resolve, reject) => {

    axios.put(WAPIAddress, {'uri': '/change_password/',
      'method': 'PUT',
      'data': JSON.stringify(params),
      'token': localStorage.getItem('token'),
      'wapiKey': wapiKey,
    })
    .then((res) => {
      resolve(res.data);
    })
      .catch((err) => {
        reject(err);
      })
  })

}



// WEBPACK FOOTER //
// ./src/controllers/controllers/user/changePassword.js